namespace Areas.ConstructionManagement {
    "use strict";


    export function viewLink(cellElement: any, cellInfo: any) {

        let linkInfo: string;

        if (cellInfo.data.sourceTable === "Transmittal") {
            linkInfo = "<a href= '/Transmittal/Profile/View/{placeholder}' target='_blank'>View</a>";
        } else if (cellInfo.data.sourceTable === "PunchList") {
            linkInfo = "<a href= '/PunchList/Profile/View/{placeholder}' target='_blank'>View</a>";
        } else if (cellInfo.data.sourceTable === "Submittal") {
            linkInfo = "<a href= '/Submittal/Profile/View/{placeholder}' target='_blank'>View</a>";
        } else if (cellInfo.data.sourceTable === "Meeting Minutes") {
            linkInfo = "<a href= '/MeetingMinutes/MeetingMinutes/View/{placeholder}' target='_blank'>View</a>";
        } else if (cellInfo.data.sourceTable === "Warranty") {
            linkInfo = "<a href= '/Warranty/Profile/View/{placeholder}' target='_blank'>View</a>";
        } else if (cellInfo.data.sourceTable === "Change Management") {
            linkInfo = "<a href= '/ChangeManagement/Profile/View/{placeholder}' target='_blank'>View</a>";
        } else if (cellInfo.data.sourceTable === "Contractor Pay") {
            linkInfo = "<a href= '/ContractorPay/Profile/View/{placeholder}' target='_blank'>View</a>";
        }

        buildCellContent(cellElement,
            () => { return cellInfo.data.profileId; },
            linkInfo);
    }


    export function createNewItem(e: any) {
        const newItemDialog = new Areas.Dialogs.CreateConstructionManagementItemDialog(() => { }, { accountId: e.component.option("accountId") });
    }

}